// removed by extract-text-webpack-plugin
module.exports = {"inputAndButtonHeight":"3rem","Blackberry":"#333D47","Bluecheese":"#615CFF","Radish":"#C20026","inputWithButtonWrapper":"Gcddca4","eventStatus":"Ga13678 G3c3c24"};